import { get } from '@services/method';
import routes from '@configs/routes.json';
import { trimLeadingSlashes } from '@utils/urlUtils';

export const projectFilesApiUrl = (path: string): string => {
  let url;
  if (!path) {
    url = routes.api.files.get;
  } else {
    let trimmedPath = trimLeadingSlashes(path);
    url = routes.api.files.getHierarchy.replace('*path', trimmedPath);
  }
  return url;
};

export const getFilesByProject = async (path: string) => {
  return await get(projectFilesApiUrl(path)).then((response) =>
    response.json()
  );
};

export const fileDownloadUrl = (path: string) => {
  let trimmedPath = trimLeadingSlashes(path);
  let url = routes.api.files.downloadUrl.replace('*path', trimmedPath);
  return url;
};
